import _ from "lodash";
import { useCallback, useMemo, useState } from "react";

export const useDataGridOutline = params => {
  const { sideNavData } = params;

  // used for leftPane selection
  const [leftPaneSelectedId, setLeftPaneSelectedId] = useState(0);
  // used for grid scroll to row
  const [activeRowId, setActiveRowId] = useState(null);

  const onVisibleRowsChange = useCallback(
    item => {
      const rowId = _.first(item);
      let current = sideNavData.find(section => section.id === rowId);

      if (!current) {
        current = sideNavData[0];
      }

      if (current) setLeftPaneSelectedId(current.id);
    },
    [sideNavData]
  );

  const handleClickSideBarItem = useCallback(
    itemId => {
      if (leftPaneSelectedId === itemId) return;
      setLeftPaneSelectedId(itemId);
      setActiveRowId(itemId);
    },
    [leftPaneSelectedId]
  );

  const gridProps = useMemo(() => {
    return {
      scrollCellData: { id: activeRowId },
      onVisibleRowsChange,
    };
  }, [activeRowId, onVisibleRowsChange]);

  const outlineProps = useMemo(() => {
    return {
      sideNavData,
      leftPaneSelectedId,
      handleClickSideBarItem,
    };
  }, [leftPaneSelectedId, handleClickSideBarItem, sideNavData]);

  return {
    gridProps,
    outlineProps,
  };
};
